import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import SwordTagWuk from '@ui-kit/components/tag/Tag.vue'
import { useSlotText } from '@/composables/useSlotText'

// Bridge component between legacy Vue 2 UI (web-ui-kit) and new Vue 3 UI (@swordhealth/ui)
// Accepts props compatible with @swordhealth/ui Tag component (https://github.com/SWORDHealth/ui/blob/master/packages/ui/src/components/tag/Tag.vue)
// But internally uses the legacy web-ui-kit Tag component (https://github.com/SWORDHealth/web-ui-kit/blob/master/src/components/tag/Tag.vue)

// Props mapping from new UI to legacy UI:
// - size: 'sm' → 'small', 'md' → 'medium', 'lg' → 'large'
// - color: accepts same values (black, white, neutral, blue, green, grey, red, yellow) + 'blue-red' for gradient
// - icon → iconLeft (new UI uses 'icon', legacy uses 'iconLeft')
// - iconRight → iconRight (both use same prop name)
// - removable → removable (both use same prop name)
// - disabled → disabled (both use same prop name)
// - text → extracted from default slot content and passed as 'text' prop to legacy component

interface XTagProps {
  // @swordhealth/ui compatible props (Vue 3)
  size?: 'sm' | 'md' | 'lg'
  color?: 'black' | 'white' | 'neutral' | 'blue' | 'green' | 'grey' | 'red' | 'yellow' | 'gradient' | 'primary' | 'secondary'
  icon?: string
  iconRight?: string
  removable?: boolean
  disabled?: boolean
  rounded?: boolean // New UI prop (maps to radiusType='full')
  semiBold?: boolean
  outlined?: boolean // New UI prop (maps to withStroke)
  removeLabel?: string // New UI prop for accessibility
  tag?: string // HTML tag (default 'span')
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SwordTag',
  props: {
    size: { default: 'md' },
    color: { default: 'blue' },
    icon: {},
    iconRight: {},
    removable: { type: Boolean },
    disabled: { type: Boolean },
    rounded: { type: Boolean },
    semiBold: { type: Boolean },
    outlined: { type: Boolean },
    removeLabel: {},
    tag: { default: 'span' }
  },
  emits: ["remove", "click"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const text = useSlotText()

const legacySize = computed(() => {
  const sizeMap = { 'sm': 'small', 'md': 'medium', 'lg': 'large' }

  return sizeMap[props.size] || 'medium'
})

const legacyColor = computed(() => {
  if (props.color === 'gradient') return 'blue-red'
  if (props.color === 'primary') return 'blue'
  if (props.color === 'secondary') return 'yellow'

  return props.color
})

const emit = __emit

function handleRemove(event: Event) {
  emit('remove', event)
}

function handleClick(event: MouseEvent) {
  emit('click', event)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SwordTagWuk, _mergeProps(_ctx.$attrs, {
    style: {'--text-display': !_unref(text) && 'none'}
  }, {
    text: _unref(text) || '',
    size: legacySize.value,
    color: legacyColor.value,
    "icon-left": __props.icon,
    "icon-right": __props.iconRight,
    removable: __props.removable,
    disabled: __props.disabled,
    "semi-bold": __props.semiBold,
    "radius-type": __props.rounded ? 'full' : 'small',
    "with-stroke": __props.outlined,
    onClickNative: handleClick,
    onRemove: handleRemove
  }), null, 16, ["style", "text", "size", "color", "icon-left", "icon-right", "removable", "disabled", "semi-bold", "radius-type", "with-stroke"]))
}
}

})